"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructFunnelData = exports.constructDeeplinkData = exports.constructDatavisorData = exports.callDataVisorEndpoint = void 0;
exports.fetchData = fetchData;
exports.setButtonCustomProperties = exports.navigateToSNAPByCheckbox = exports.fireGtmSearch = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _dateFns = require("date-fns");

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _utils = require("../utils");

var _constant = require("../constant");

var setButtonCustomProperties = function setButtonCustomProperties(isLoading) {
  return isLoading ? {
    paddingLeft: '0',
    paddingRight: '0',
    paddingTop: '6px',
    paddingBottom: '6px'
  } : {
    paddingLeft: '0',
    paddingRight: '0',
    paddingTop: '1rem',
    paddingBottom: '1rem'
  };
};

exports.setButtonCustomProperties = setButtonCustomProperties;

var fireGtmSearch = function fireGtmSearch(origin, destination, tripDates, passengers, promoCode, geoid, tripType, fireGtm) {
  var appName = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 'Flights';
  var obj = {
    event: 'trackEventNoEcommerce',
    'eventDetails.category': 'hpsearchwidget',
    'eventDetails.action': "click",
    'eventDetails.label': "".concat(appName, " | ").concat(origin.StationCode, " - ").concat(destination.StationCode, " (").concat((0, _utils.findGtmTag)(origin.iconName), " - ").concat((0, _utils.findGtmTag)(destination.iconName), ") | ").concat((0, _utils.findCarrierGtmTag)(destination.Provider), " | ").concat((0, _utils.changeDateFormat)(tripDates.departureDate)).concat(tripDates.returnDate ? " - ".concat((0, _utils.changeDateFormat)(tripDates.returnDate)) : '', " | ADL=").concat(passengers.adult, ", CHD=").concat(passengers.child, ", INF=").concat(passengers.infant, " | ").concat((0, _utils.findTripGtmTag)(tripType), " | Economy").concat(promoCode ? " | ".concat(promoCode) : '', " | geoid=").concat(geoid, " ")
  };
  if (obj && fireGtm) fireGtm(obj, 'true');
};

exports.fireGtmSearch = fireGtmSearch;

var constructFunnelData = function constructFunnelData(tripType, tripDates, destination, passengers, promoCode, showTravelClass, showFswCabinClass, travelClass, currency, geoid, locale, isMobile, unifiedListingConfig, operatingAirline, origin, cityLevelGrouping) {
  // sets geoid as CN if host is .cn
  var geoIdValue = _utilities.default.isChinaDomainName() ? _constant.CHINA_GEO : geoid;
  var originValue = (0, _utils.fetchCode)(origin);
  var destinationValue = (0, _utils.fetchCode)(destination);
  var funnelData = {
    searchContext: {
      flightJourney: {
        journeyType: tripType.toUpperCase(),
        journeyDetails: [{
          departDate: (0, _dateFns.format)(tripDates.departureDate, _constant.DATE_FORMAT.LISTING_DATE_FORMAT),
          returnDate: tripType.toUpperCase() === _constant.TRIP_TYPES.RETURN ? (0, _dateFns.format)(tripDates.returnDate, _constant.DATE_FORMAT.LISTING_DATE_FORMAT) : '',
          origin: originValue,
          destination: destinationValue,
          isOriginCity: (0, _utils.isCity)(origin.StationType) && cityLevelGrouping,
          isDestinationCity: (0, _utils.isCity)(destination.StationType) && cityLevelGrouping
        }],
        passengers: {
          adult: passengers.adult,
          child: passengers.child,
          infant: passengers.infant
        }
      },
      promocode: promoCode && promoCode.length > 0 ? promoCode : null,
      cabinClass: showTravelClass || showFswCabinClass ? travelClass.travelClass : null
    },
    userContext: {
      currency: currency.toUpperCase(),
      geoId: geoIdValue,
      locale: locale,
      platform: isMobile ? _constant.PLATFORM.MOBILE : _constant.PLATFORM.WEB
    },
    inventoryContext: {
      airlineProfile: unifiedListingConfig && unifiedListingConfig.airlineProfile ? unifiedListingConfig.airlineProfile : _constant.AIRLINE_PROFILE.ALL,
      type: unifiedListingConfig && unifiedListingConfig.type ? unifiedListingConfig.type : _constant.TYPE.PAIRED,
      provider: operatingAirline === _constant.AIRLINES.FLYBEYOND ? _constant.AIRLINES.OTA : operatingAirline
    },
    metaData: {
      dest: origin && origin.Dest ? origin.Dest : ''
    }
  };
  return funnelData;
};

exports.constructFunnelData = constructFunnelData;

var navigateToSNAPByCheckbox = function navigateToSNAPByCheckbox(environment, destination, passengers, origin, tripDates, promoCode, currency, locale, isShowSnapInNewWindow) {
  var url = (0, _utils.getSNAPRedirection)({
    environment: environment,
    destination: destination,
    passengers: passengers,
    origin: origin,
    tripDates: tripDates,
    promoCode: promoCode,
    currency: currency,
    locale: locale
  });

  if (url) {
    if (isShowSnapInNewWindow) {
      // eslint-disable-next-line max-len
      var strWindowFeatures = "location=yes,height=".concat(_constant.SNAP_WINDOW.HEIGHT, ",width=").concat(_constant.SNAP_WINDOW.WIDTH, ",scrollbars=yes,status=yes");
      window.open(url, '_blank', strWindowFeatures);
    } else window.open(url, '_blank');
  }
};

exports.navigateToSNAPByCheckbox = navigateToSNAPByCheckbox;

var constructDatavisorData = function constructDatavisorData(origin, destination, tripType, tripDates, passengers, dataVisorToken, isEdit) {
  var data = {
    Depart: origin.StationCode,
    Arrival: destination.StationCode,
    ArrivalDate: tripType.toUpperCase() === _constant.TRIP_TYPES.RETURN ? (0, _dateFns.format)(tripDates.returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT) : 'N',
    DeparDate: (0, _dateFns.format)(tripDates.departureDate, _constant.DATE_FORMAT.AA_DATE_FORMAT),
    Adult: passengers.adult,
    Child: passengers.child,
    Infants: passengers.infant,
    DVToken: dataVisorToken,
    GaId: (0, _utils.getCookie)(_constant.AA_GAID_COOKIE_NAME),
    Event: isEdit ? _constant.DATA_VISOR_EVENT.EDIT_PAGE : _constant.DATA_VISOR_EVENT.HOME_PAGE
  };
  return data;
};

exports.constructDatavisorData = constructDatavisorData;

var constructDeeplinkData = function constructDeeplinkData(baseCurrency, isLogin, bigLoyaltyToggleValue, type, locale, originObj, destObj, dates, pax, currency, promo) {
  var data = {
    params: {
      base_currency: baseCurrency.data,
      isBigLoyaltyRedemptionEnabled: isLogin ? bigLoyaltyToggleValue : false
    },
    triptype: type.toUpperCase() === _constant.TRIP_TYPES.RETURN ? 'roundtrip' : 'oneway',
    culture_code: locale.replace('-', '/'),
    depart: originObj.StationCode,
    arrival: destObj.StationCode,
    departdate: (0, _dateFns.format)(dates.departureDate, _constant.DATE_FORMAT.AA_DATE_FORMAT),
    returndate: type.toUpperCase() === _constant.TRIP_TYPES.RETURN ? (0, _dateFns.format)(dates.returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT) : 'N',
    totaladult: pax.adult,
    totalchild: pax.child,
    totalinfant: pax.infant,
    currency: currency.toUpperCase(),
    sort: 'ST',
    promo: (promo && promo.length) > 0 ? promo : 'N',
    exclude_domain: !!_utilities.default.isLocalEnvironment()
  };
  return data;
};

exports.constructDeeplinkData = constructDeeplinkData;

function fetchData(_x, _x2, _x3) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, headers, funnelData) {
    var result;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _utilities.default.post(url, headers, funnelData);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchData.apply(this, arguments);
}

var callDataVisorEndpoint = function callDataVisorEndpoint(enableDataVisor, originObj, destObj, type, dates, pax, isEdit, endpointConfig, environment, domain) {
  if (enableDataVisor) {
    var dataVisorHeader = {
      'Content-Type': 'application/json'
    };
    var dataVisorToken = localStorage.getItem('DVToken');
    var dataVisorData = constructDatavisorData(originObj, destObj, type, dates, pax, dataVisorToken, isEdit);

    if (dataVisorToken) {
      var dataVisorUrl = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'dataVisor'), environment, domain);
      fetchData(dataVisorUrl, dataVisorHeader, dataVisorData);
    }
  }
};

exports.callDataVisorEndpoint = callDataVisorEndpoint;